var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.source.name === "Datis" ? "list-table-wrapper" : "" },
    [
      _c(
        "table",
        {
          staticClass: "table widget-table line-height-tight",
          staticStyle: { "margin-bottom": "0" },
        },
        [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "th-filters", attrs: { colspan: 99 } }, [
                _c("div", { staticClass: "widget-filters" }, [
                  _c("div", [
                    _vm.source.name === "Datis"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.textFilterDati,
                              expression: "textFilterDati",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: _vm.filterPlaceholder,
                          },
                          domProps: { value: _vm.textFilterDati },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.SearchDatiByName($event)
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.textFilterDati = $event.target.value
                            },
                          },
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.textFilter,
                              expression: "textFilter",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: _vm.filterPlaceholder,
                          },
                          domProps: { value: _vm.textFilter },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.textFilter = $event.target.value
                            },
                          },
                        }),
                  ]),
                  _vm._v(" "),
                  _vm.source.name === "Events"
                    ? _c(
                        "div",
                        {
                          staticClass: "toolbar-control",
                          staticStyle: {
                            display: "flex",
                            flex: "1 0 auto",
                            "line-height": "1",
                          },
                          on: { click: _vm.handleCheck },
                        },
                        [
                          _c("span", [
                            _c(
                              "span",
                              {
                                staticClass: "checkbox",
                                class: { check: _vm.onlyAlert },
                              },
                              [_c("i", { staticClass: "fa fa-check" })]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "line-height": "1",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("home.widgets.onlyAlert")) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "queryDati-wrapper",
                          on: { click: _vm.SearchDatiByName },
                        },
                        [_c("i", { staticClass: "fa fa-search" })]
                      ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "tr",
              [
                _vm._l(_vm.headers, function (head, index) {
                  return _c(
                    "th",
                    {
                      key: index,
                      staticClass: "capitalize",
                      style: { width: 100 / _vm.headers.length + "%" },
                    },
                    [_vm._v("\n        " + _vm._s(head) + "\n      ")]
                  )
                }),
                _vm._v(" "),
                _vm.source.name === "Datis"
                  ? _c("th", {
                      staticClass: "px-0",
                      staticStyle: { width: "40px" },
                    })
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm.isLoading
            ? _c("tbody", [
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "text-center p-4",
                      attrs: { colspan: "99" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "spinner-border text-secondary",
                          attrs: { role: "status" },
                        },
                        [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(_vm._s(_vm.$t("global.loading"))),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ])
            : _c(
                "tbody",
                _vm._l(_vm.filteredList, function (item) {
                  return _c(
                    "tr",
                    {
                      class: item.className,
                      on: {
                        click: function ($event) {
                          return _vm.handleClick(item)
                        },
                      },
                    },
                    [
                      !!item.rowType && item.rowType === "lostCom"
                        ? [
                            _c(
                              "td",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "DevicesShow",
                                        params: { id: item.rowData.dati.id },
                                      },
                                      tag: "a",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "widget-list-first-label underline m-0",
                                      },
                                      [_vm._v(_vm._s(item.rowData.dati.name))]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _vm.isLostcomAged(item) &&
                                _vm.useDvFlagAccess(
                                  "beepiz-dashboard-stop-lost-com-session-can:update"
                                )
                                  ? _c(
                                      "UiButton",
                                      {
                                        staticClass:
                                          "btn-outline-danger btn-sm d-inline-block text-truncate",
                                        attrs: {
                                          disabled: _vm.lostComDisableButton,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.handleRemoveLostcom(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-stop-circle mr-1",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.$t("global.stop")) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("strong", [
                                  _c("i", {
                                    staticClass: "zmdi zmdi-network-off",
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("home.widgets.list.lostcom")
                                      ) +
                                      "\n          "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("UiRelativeDate", {
                                  attrs: {
                                    date: item.rowData.lost_com_at.date,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !!item.rowType && item.rowType === "vocal"
                        ? [
                            _c(
                              "td",
                              { attrs: { align: "right" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "DevicesShow",
                                        params: { id: item.rowData.dati.id },
                                      },
                                      tag: "a",
                                    },
                                  },
                                  [
                                    _c(
                                      "strong",
                                      {
                                        staticClass:
                                          "widget-list-first-label underline m-0",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "home.widgets.vocal.vocal_message"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "UiButton",
                                  {
                                    staticClass:
                                      "btn-light btn-sm d-inline-block text-truncate",
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.playVocal(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-play-circle mr-1",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("global.lire")) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td"),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !!item &&
                      !!item.cellsMarkup &&
                      item.cellsMarkup.length == _vm.headers.length &&
                      !_vm.notInRowType(item.rowType)
                        ? [
                            _vm._l(item.cellsMarkup, function (col, keyCol) {
                              return [
                                !item.cellsLink[keyCol]
                                  ? _c("td", {
                                      key: item.key + "-" + keyCol + "no-link",
                                      staticClass: "widget-list-cell",
                                      domProps: { innerHTML: _vm._s(col) },
                                    })
                                  : _c("router-link", {
                                      key: item.key + "-" + keyCol + "link",
                                      staticClass: "widget-list-cell link",
                                      attrs: {
                                        to: item.cellsLink[keyCol],
                                        tag: "td",
                                      },
                                      domProps: { innerHTML: _vm._s(col) },
                                    }),
                              ]
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      item.cellsMarkup.length != _vm.headers.length
                        ? _c("td", {
                            key: item.key,
                            attrs: { colspan: _vm.headers.length },
                            domProps: {
                              innerHTML: _vm._s(
                                item.cellsMarkup ? item.cellsMarkup[0] : ""
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.source.name === "Datis"
                        ? _c(
                            "td",
                            {
                              staticClass: "px-0",
                              staticStyle: { width: "40px" },
                            },
                            [
                              !!item &&
                              item.className !== "no-item" &&
                              item.type !== "accessories"
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "d-inline-flex align-items-center justify-content-center btn btn-lg px-3 rounded",
                                      staticStyle: {
                                        border: "none",
                                        background: "transparent",
                                      },
                                      attrs: { "aria-label": "TODO" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleTarget(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-map-marker",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
        ]
      ),
      _vm._v(" "),
      _vm.source.name === "Datis"
        ? _c("b-pagination", {
            attrs: {
              disabled: _vm.rows < _vm.perpage || _vm.isLoading,
              "total-rows": _vm.rows,
              "per-page": _vm.perpage,
              "hide-ellipsis": "",
            },
            on: { change: _vm.changeCurrentPage },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }